<template>
  <layout>
    <page-header :actions="actions" :header="$t('general.new_layout_vehicle_availability')" />
    <div class="content">
      <AdminTable v-if="currentDivision" ref="table" admin-table v-bind="tableProps">
        <template #zone_a.name="{ item }">
          <div :class="[item.zone_a ? '' : mutedClass]">
            {{ item.zone_a ? item.zone_a.name : textAny }}
          </div>
        </template>
        <template #zone_b.name="{ item }">
          <div :class="[item.zone_b ? '' : mutedClass]">
            {{ item.zone_b ? item.zone_b.name : textAny }}
          </div>
        </template>
        <template #vehicles="{ item }">
          <ul class="vehicle-list">
            <li v-for="vehicle in item.vehicles" :key="vehicle.id">
              <span>{{ vehicle.name }}:</span>
              <strong>{{ availabilityLabel(vehicle) }}</strong>
            </li>
          </ul>
        </template>
      </AdminTable>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehicleAvailabilityApi from './Api'

const base = 'vehicle_availability'

export default {
  name: 'VehicleAvailabilityIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      tableProps: {
        base,
        apiBuilder: () =>
          new VehicleAvailabilityApi().setParameter('division_id', this.currentDivision.id),
        sortBy: 'updated',
        sortDesc: true,
        perPage: 1000,
        columns: [
          { key: 'id', label: this.$t('general.id') },
          {
            key: 'zone_a.name',
            label: this.$t('vehicles.attributes.pricing.zone_a.label'),
            // thClass: 'text-right',
          },
          {
            key: 'zone_b.name',
            label: this.$t('vehicles.attributes.pricing.zone_b.label'),
          },
          {
            key: 'vehicles',
            label: this.$t('vehicles.zone_to_zone_vehicles'),
            formatter: value =>
              value && value.length ? value.map(v => v.name).join(', ') : '—',
          },
        ],
        rowActions: () => {
          const actions = []
          if (this.$allows('vehicles.update') || this.$allows('vehicles.view')) {
            actions.push('edit')
          }
          if (this.$allows('vehicles.delete')) {
            actions.push('delete')
          }
          return actions
        },
        bulkActions: () => [],
      },
    }
  },

  computed: {
    textAny() {
      return `<${this.$t('general.any')}>`
    },
    mutedClass() {
      return {
        'text-muted': true,
        italic: true,
      }
    },
    actions() {
      if (!this.$allows('vehicles.create') || !this.currentDivision) {
        return []
      }
      return [
        {
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({ name: `${base}.create` })
          },
        },
      ]
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },

  methods: {
    availabilityLabel(vehicle) {
      const code = vehicle?.pivot?.availability
      if (!code) {
        return '—'
      }
      return this.$t(`vehicles.price_zone_condition.${code}`)
    },
  },
}
</script>

<style scoped>
.vehicle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  color: #787878;
  font-size: 0.775rem;
}
.vehicle-list li {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}
.vehicle-list li strong {
  color: #555;
}
</style>
